module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/home-category-173-0e05bb.svg";